import type * as monaco from 'monaco-editor'

export const FPlusDefaultFormattingWidth = 120

export const FPlusDefaultFontWidth = 6.56
export const FPlusEditorOptions: monaco.editor.IStandaloneEditorConstructionOptions =
  {
    autoIndent: 'full',
    lineNumbers: 'on',
    readOnly: false,
    glyphMargin: false,
    overviewRulerLanes: 0,
    hideCursorInOverviewRuler: true,
    minimap: { enabled: false },
    folding: true,
    foldingStrategy: 'indentation',
    showFoldingControls: 'always',
    suggest: {
      preview: true,
      previewMode: 'subwordSmart',
    },
    hover: {
      delay: 600,
    },
    lineDecorationsWidth: 15,
    lineHeight: 14,
    suggestLineHeight: 20,
    suggestFontSize: 13,
    fontLigatures: "'liga', 'calt', 'ss19'", // Matches the features the font-code utility applies to the viewers
    fontSize: 12,
    fontFamily:
      'Cascadia Code, Consolas, IBM Plex Mono, Ubuntu Mono, monospace',
  }
